<br>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-header" style="border-style: none;">
            <div class="font-weight-bold mt-2" style="text-align: center;">
              <span class="text-lg sign-in-line">FORGOT PASSWORD</span>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="forgotPasswordForm">
              <div class="p-fluid p-col-12">
                <span class="p-float-label">
                  <input type="text" [(ngModel)]="userName" formControlName="email" id="inputtext" pInputText disabled><br>
                  <label for="Username" class="mb-1">Email</label>
                </span>
              </div><br>
              <span class="text-danger"
                *ngIf="(forgotPasswordFormControl.email.touched) && forgotPasswordFormControl.email.errors?.required">
              </span>
              <span class="text-danger"
                *ngIf="forgotPasswordFormControl.email.touched && forgotPasswordFormControl.email.errors?.email">
                Please enter a valid email address
              </span>
              <div class="p-d-flex p-jc-between">
                <div class="col-md-6" style="text-align: center;">
                  <button pButton type="button" label="Submit" [disabled]="!forgotPasswordForm.valid" (click)="generateForgotPasswordEmail(forgotPasswordForm)"
                    class="btn-login"></button>
                </div>
                <div class="col-md-6" style="text-align: center;">
                  <button pButton type="button" (click)="onCancel()"label="Back to log in" class="btn-login"></button>
                </div>
              </div>
              <br>
            </form>
          </div>
        </div>     
      </div>
      <div class="col-md-4"></div>
    </div>
  </div>
</div>
<p-dialog header="Success" [(visible)]="saveModal" [modal]="true" [style]="{width: '30vw'}" [draggable]="false"
  [closable]="false" [resizable]="false">
  <br>
 <div class="card p-m-2 p-p-2">
  <p class="text-center">A password reset link has been sent to<strong style="color: #4681ca;"> {{userName}}</strong></p>
  <p class="text-center">Please check your inbox to continue.</p>

 </div>
  <ng-template pTemplate="footer">
    <div class="text-center">
      <p-button icon="pi pi-check" (click)="saveModal=false;saveRedirect();" label="Ok" styleClass="p-button-primary p-button-sm">
      </p-button>
    </div>    
  </ng-template>
</p-dialog>